var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c43e423fc908c5122fe5967b389a5d71cad6eea6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["dolce-live-frontend@mgt-r1"]={id:"c43e423fc908c5122fe5967b389a5d71cad6eea6"};
      